import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Styles/TermsOfUse.css";

function TermsOfUse() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <main className="terms_page">
      <div className="terms_inner">
        <p className="terms_kicker">PyLoan</p>
        <h1>Terms of Use</h1>
        <p className="terms_updated">Last updated: 22 October 2026</p>

        <section>
          <h2>1. Educational content</h2>
          <p>
            PyLoan publishes general educational information about loans,
            government-supported schemes and related application questions. The
            website is not a lender, bank, NBFC, broker, financial adviser or
            government authority. Nothing on the website is a promise of loan
            approval, a quotation, an offer or personalised financial advice.
          </p>
        </section>

        <section>
          <h2>2. Verify current rules</h2>
          <p>
            Scheme rules, eligibility, rates, fees, collateral requirements,
            subsidies and application procedures can change. Check the latest
            information with the relevant official portal, bank or financial
            institution before making a decision. The relevant authority alone
            decides whether to approve an application and on what terms.
          </p>
        </section>

        <section>
          <h2>3. Contact form</h2>
          <p>
            The contact form is for general questions about website content. Do
            not submit a loan application or share passwords, OTPs, bank login
            credentials or full card numbers. We do not accept or process loan
            applications and do not connect applicants with lenders.
          </p>
        </section>

        <section>
          <h2>4. External links</h2>
          <p>
            PyLoan may link to government portals, banks and other third-party
            websites. We do not control those sites and are not responsible for
            their content, availability, privacy practices or decisions.
          </p>
        </section>

        <section>
          <h2>5. Intellectual property</h2>
          <p>
            Unless stated otherwise, PyLoan’s original text, branding and
            design are protected by applicable intellectual property laws. You
            may read and share links for personal, non-commercial use. Do not
            copy or republish substantial portions without written permission.
          </p>
        </section>

        <section>
          <h2>6. Changes and contact</h2>
          <p>
            We may update these terms as the website changes. Continued use of
            the website after an update means you accept the revised terms.
            Questions can be sent to <a href="mailto:Mudraloanhelp0@gmail.com">Mudraloanhelp0@gmail.com</a>.
          </p>
        </section>

        <p className="terms_footer">
          <Link to="/privacy_policy">Read the Privacy Policy</Link>
        </p>
      </div>
    </main>
  );
}

export { TermsOfUse };
